const NewsPresets = {
  NewsItem: {
    attrs: {
      showDislikeButton: true
    },
    slots: {
      tags: {
        attrs: {
          color: "#F5EA98",
          textColor: "black"
        }
      },
      peopleTags: {
        attrs: {
          color: "#EAD430",
          textColor: "black"
        }
      }
    }
  }
};
export {
  NewsPresets as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTmV3c1ByZXNldHMuanMiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb25zdGFudHMvY29tcG9uZW50cy9OZXdzUHJlc2V0cy5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCB7XG4gIE5ld3NJdGVtOiB7XG4gICAgYXR0cnM6IHtcbiAgICAgIHNob3dEaXNsaWtlQnV0dG9uOiB0cnVlLFxuICAgIH0sXG4gICAgc2xvdHM6IHtcbiAgICAgIHRhZ3M6IHtcbiAgICAgICAgYXR0cnM6IHtcbiAgICAgICAgICBjb2xvcjogXCIjRjVFQTk4XCIsXG4gICAgICAgICAgdGV4dENvbG9yOiBcImJsYWNrXCIsXG4gICAgICAgIH0sXG4gICAgICB9LFxuICAgICAgcGVvcGxlVGFnczoge1xuICAgICAgICBhdHRyczoge1xuICAgICAgICAgIGNvbG9yOiBcIiNFQUQ0MzBcIixcbiAgICAgICAgICB0ZXh0Q29sb3I6IFwiYmxhY2tcIixcbiAgICAgICAgfSxcbiAgICAgIH0sXG4gICAgfSxcbiAgfSxcbn07XG4iXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBZSxjQUFBO0FBQUEsRUFDYixVQUFVO0FBQUEsSUFDUixPQUFPO0FBQUEsTUFDTCxtQkFBbUI7QUFBQSxJQUNwQjtBQUFBLElBQ0QsT0FBTztBQUFBLE1BQ0wsTUFBTTtBQUFBLFFBQ0osT0FBTztBQUFBLFVBQ0wsT0FBTztBQUFBLFVBQ1AsV0FBVztBQUFBLFFBQ1o7QUFBQSxNQUNGO0FBQUEsTUFDRCxZQUFZO0FBQUEsUUFDVixPQUFPO0FBQUEsVUFDTCxPQUFPO0FBQUEsVUFDUCxXQUFXO0FBQUEsUUFDWjtBQUFBLE1BQ0Y7QUFBQSxJQUNGO0FBQUEsRUFDRjtBQUNIOyJ9
